import Skeleton from 'react-loading-skeleton';

import { useGetStateByStateKey } from '../../../../../api/lending/lapiHooks';
import { useIsMobile } from '../../../../../hooks/useIsMobile';

export const MajorShareholdersSubTitle = ({
  limit = 2,
}: {
  limit?: number;
}) => {
  const { state, loadingState } = useGetStateByStateKey();
  const { isMobile } = useIsMobile();

  if (isMobile) limit = 1;

  if (loadingState) return <Skeleton containerTestId="loading-skeleton" />;

  const shareholders = state?.application?.people
    ?.filter((person) => person.roles?.includes('shareholder'))
    .map((shareholder) => ({
      id: shareholder.uid,
      title: shareholder.title,
      firstName: shareholder.first_name,
      lastName: shareholder.last_name,
    }));

  const overflow = shareholders && shareholders.length > limit;

  return (
    shareholders && (
      <div className="flex gap-s text-xs font-med text-structure-40">
        {shareholders?.slice(0, limit).map((shareholder) => (
          <p
            key={shareholder.id}
            className="fs-mask m-0 max-w-[10rem] overflow-hidden truncate first-letter:capitalize sm:max-w-[4rem]"
          >
            {shareholder.title} {shareholder.firstName} {shareholder.lastName}
          </p>
        ))}
        {overflow && (
          <p className="m-0 shrink-0">{`(${limit} of ${shareholders.length} shown)`}</p>
        )}
      </div>
    )
  );
};
